import { toString, Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { list_type, union_type, bool_type, int32_type, class_type, record_type, option_type, string_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { join } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { ofArray, head, sortBy, append, singleton, isEmpty, choose, map } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { FSharpResult$2, Result_Map, Result_MapError } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { unwrap, value as value_2, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toUpper, trimWhiteSpace, $007CNotEmpty$007C_$007C, $007CInt$007C_$007C, $007CDecimal$007C_$007C, $007CDateTime$007C_$007C, $007CBool$007C_$007C } from "../Shopfoo.Common/String.js";
import { PrettyPrint_prettyPrintObject, PrettyPrint_prettyPrintString } from "../Shopfoo.Common/Common.js";
import { map as map_1, toArray, empty, singleton as singleton_1, append as append_1, delay, toList, length, tryExactlyOne } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { comparePrimitives } from "../fable_modules/fable-library-js.4.24.0/Util.js";

export class ErrorMessage extends Record {
    constructor(Message, InnerMessage) {
        super();
        this.Message = Message;
        this.InnerMessage = InnerMessage;
    }
}

export function ErrorMessage_$reflection() {
    return record_type("Shopfoo.Domain.Types.Errors.ErrorMessage", [], ErrorMessage, () => [["Message", string_type], ["InnerMessage", option_type(string_type)]]);
}

export function ErrorMessage_Create_27AED5E3(message, innerMessage) {
    return new ErrorMessage(message, innerMessage);
}

export function ErrorMessage_Combine_Z57E0834A(errorMessages) {
    let matchValue;
    return new ErrorMessage(join("\n", map((_arg) => _arg.Message, errorMessages)), (matchValue = choose((_arg_1) => _arg_1.InnerMessage, errorMessages), isEmpty(matchValue) ? undefined : join("\n", matchValue)));
}

export function ErrorMessage__get_FullMessage(this$) {
    const matchValue = this$.InnerMessage;
    if (matchValue == null) {
        return this$.Message;
    }
    else {
        return `${this$.Message} (${matchValue})`;
    }
}

export function Validation_toValidation(result) {
    return Result_MapError(singleton, result);
}

export class Validation_ValidationBuilder {
    constructor() {
    }
}

export function Validation_ValidationBuilder_$reflection() {
    return class_type("Shopfoo.Domain.Types.Errors.Validation.ValidationBuilder", undefined, Validation_ValidationBuilder);
}

export function Validation_ValidationBuilder_$ctor() {
    return new Validation_ValidationBuilder();
}

export function Validation_ValidationBuilder__BindReturn_Z2A87A9DF(_, x, f) {
    return Result_Map(f, x);
}

export function Validation_ValidationBuilder__MergeSources_Z65609D20(_, x, y) {
    let matchResult, v1, v2, e1, e2, e;
    const copyOfStruct = x;
    if (copyOfStruct.tag === 1) {
        const copyOfStruct_1 = y;
        if (copyOfStruct_1.tag === 1) {
            matchResult = 1;
            e1 = copyOfStruct.fields[0];
            e2 = copyOfStruct_1.fields[0];
        }
        else {
            matchResult = 2;
            e = copyOfStruct.fields[0];
        }
    }
    else {
        const copyOfStruct_2 = y;
        if (copyOfStruct_2.tag === 1) {
            matchResult = 2;
            e = copyOfStruct_2.fields[0];
        }
        else {
            matchResult = 0;
            v1 = copyOfStruct.fields[0];
            v2 = copyOfStruct_2.fields[0];
        }
    }
    switch (matchResult) {
        case 0:
            return new FSharpResult$2(0, [[v1, v2]]);
        case 1:
            return new FSharpResult$2(1, [append(e1, e2)]);
        default:
            return new FSharpResult$2(1, [e]);
    }
}

export const Validation_validation = Validation_ValidationBuilder_$ctor();

export class Guards_GuardClauseError extends Record {
    constructor(EntityName, ErrorMessage) {
        super();
        this.EntityName = EntityName;
        this.ErrorMessage = ErrorMessage;
    }
}

export function Guards_GuardClauseError_$reflection() {
    return record_type("Shopfoo.Domain.Types.Errors.Guards.GuardClauseError", [], Guards_GuardClauseError, () => [["EntityName", string_type], ["ErrorMessage", string_type]]);
}

export class Guards_GuardCriteria extends Record {
    constructor(PropertyName, MaxLength, MinLength, Required) {
        super();
        this.PropertyName = PropertyName;
        this.MaxLength = MaxLength;
        this.MinLength = MinLength;
        this.Required = Required;
    }
}

export function Guards_GuardCriteria_$reflection() {
    return record_type("Shopfoo.Domain.Types.Errors.Guards.GuardCriteria", [], Guards_GuardCriteria, () => [["PropertyName", string_type], ["MaxLength", option_type(int32_type)], ["MinLength", option_type(int32_type)], ["Required", bool_type]]);
}

export function Guards_GuardCriteria_Create_71C5AF32(name, maxLength, minLength, required) {
    return new Guards_GuardCriteria(name, maxLength, minLength, defaultArg(required, false));
}

export function Guards_GuardCriteria_get_None() {
    return Guards_GuardCriteria_Create_71C5AF32("");
}

export class Guards_Guard {
    constructor(entityName) {
        this["EntityName@"] = entityName;
    }
}

export function Guards_Guard_$reflection() {
    return class_type("Shopfoo.Domain.Types.Errors.Guards.Guard", undefined, Guards_Guard);
}

export function Guards_Guard_$ctor_Z721C83C5(entityName) {
    return new Guards_Guard(entityName);
}

export function Guards_Guard__get_EntityName(__) {
    return __["EntityName@"];
}

export function Guards_Guard__IsBoolean_Z721C83C5(this$, value) {
    const activePatternResult = $007CBool$007C_$007C(value);
    if (activePatternResult != null) {
        const b = activePatternResult;
        return new FSharpResult$2(0, [b]);
    }
    else {
        const errorMessage = `should be a boolean but was ${PrettyPrint_prettyPrintString(value)}`;
        return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), errorMessage)]);
    }
}

export function Guards_Guard__IsDateTime_Z721C83C5(this$, value) {
    const activePatternResult = $007CDateTime$007C_$007C(value);
    if (activePatternResult != null) {
        const value_1 = activePatternResult;
        return new FSharpResult$2(0, [value_1]);
    }
    else {
        const errorMessage = `should be a DateTime but was ${PrettyPrint_prettyPrintString(value)}`;
        return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), errorMessage)]);
    }
}

export function Guards_Guard__IsDecimal_Z721C83C5(this$, value) {
    const activePatternResult = $007CDecimal$007C_$007C(value);
    if (activePatternResult != null) {
        const value_1 = activePatternResult;
        return new FSharpResult$2(0, [value_1]);
    }
    else {
        const errorMessage = `should be a decimal but was ${PrettyPrint_prettyPrintString(value)}`;
        return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), errorMessage)]);
    }
}

export function Guards_Guard__IsInteger_Z721C83C5(this$, value) {
    const activePatternResult = $007CInt$007C_$007C(value);
    if (activePatternResult != null) {
        const value_1 = activePatternResult | 0;
        return new FSharpResult$2(0, [value_1]);
    }
    else {
        const errorMessage = `should be an integer but was ${PrettyPrint_prettyPrintString(value)}`;
        return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), errorMessage)]);
    }
}

export function Guards_Guard__IsNotEmpty_259D9DD2(this$, value, allowEmpty) {
    let matchResult;
    if ($007CNotEmpty$007C_$007C(value) != null) {
        matchResult = 0;
    }
    else if (allowEmpty != null) {
        if (allowEmpty) {
            matchResult = 0;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0:
            return new FSharpResult$2(0, [value]);
        default: {
            const errorMessage = `should not be empty but was ${PrettyPrint_prettyPrintString(value)}`;
            return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), errorMessage)]);
        }
    }
}

export function Guards_Guard__IsNotEmptyGuid_244AC511(this$, value) {
    if (value === "00000000-0000-0000-0000-000000000000") {
        return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), "should not be an empty guid")]);
    }
    else {
        return new FSharpResult$2(0, [value]);
    }
}

export function Guards_Guard__HasExactlyOneElement_404FCA0C(this$, sequence) {
    const matchValue = tryExactlyOne(sequence);
    if (matchValue == null) {
        const errorMessage = `should have exactly one element but had ${length(sequence)}`;
        return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), errorMessage)]);
    }
    else {
        return new FSharpResult$2(0, [value_2(matchValue)]);
    }
}

export function Guards_Guard__NotSupported_1505(this$, value) {
    const errorMessage = `${PrettyPrint_prettyPrintObject(value)} is not supported`;
    return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), errorMessage)]);
}

export function Guards_Guard__Satisfies_65910D14(this$, value, condition, error) {
    if (condition) {
        return new FSharpResult$2(0, [value]);
    }
    else {
        return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), error)]);
    }
}

export function Guards_Guard__Satisfies_654AEC11(this$, condition, error) {
    return Guards_Guard__Satisfies_65910D14(this$, undefined, condition, error);
}

export function Guards_Guard__Satisfies_61128B72(this$, value, criteria) {
    const len = trimWhiteSpace(value).length | 0;
    const issuesWithRank = toList(delay(() => append_1(criteria.Required ? ((len === 0) ? singleton_1([1, "required"]) : (empty())) : (empty()), delay(() => {
        let matchValue_1, n_1;
        return append_1((matchValue_1 = criteria.MinLength, (matchValue_1 != null) ? ((len < matchValue_1) ? ((n_1 = (matchValue_1 | 0), singleton_1([2, `${n_1} character long min`]))) : (empty())) : (empty())), delay(() => {
            const matchValue_2 = criteria.MaxLength;
            let matchResult, n_3;
            if (matchValue_2 != null) {
                if (len > matchValue_2) {
                    matchResult = 0;
                    n_3 = matchValue_2;
                }
                else {
                    matchResult = 1;
                }
            }
            else {
                matchResult = 1;
            }
            switch (matchResult) {
                case 0:
                    return singleton_1([3, `${n_3} character long max`]);
                default: {
                    return empty();
                }
            }
        }));
    }))));
    if (isEmpty(issuesWithRank)) {
        return new FSharpResult$2(0, [value]);
    }
    else {
        const issues = join(", ", map((tuple_1) => tuple_1[1], sortBy((tuple) => tuple[0], issuesWithRank, {
            Compare: comparePrimitives,
        })));
        return new FSharpResult$2(1, [new Guards_GuardClauseError(Guards_Guard__get_EntityName(this$), `${criteria.PropertyName} '${value}' does not satisfy the criteria: ${issues}, trailing whitespaces excluded`)]);
    }
}

export class Http_HttpVerb extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Get", "Post", "Put", "Patch", "Delete"];
    }
}

export function Http_HttpVerb_$reflection() {
    return union_type("Shopfoo.Domain.Types.Errors.Http.HttpVerb", [], Http_HttpVerb, () => [[], [], [], [], []]);
}

export class Http_HttpStatus extends Record {
    constructor(Code, Label, Content, Request, Verb, Uri) {
        super();
        this.Code = (Code | 0);
        this.Label = Label;
        this.Content = Content;
        this.Request = Request;
        this.Verb = Verb;
        this.Uri = Uri;
    }
}

export function Http_HttpStatus_$reflection() {
    return record_type("Shopfoo.Domain.Types.Errors.Http.HttpStatus", [], Http_HttpStatus, () => [["Code", int32_type], ["Label", string_type], ["Content", option_type(string_type)], ["Request", option_type(string_type)], ["Verb", Http_HttpVerb_$reflection()], ["Uri", option_type(class_type("System.Uri"))]]);
}

export function Http_HttpStatus__Explain(this$) {
    let matchValue, matchValue_1, request, matchValue_2, content;
    return `HTTP Status Code ${this$.Code} (${this$.Label})${(matchValue = this$.Uri, (matchValue != null) ? (`
${toUpper(toString(this$.Verb))} ${toString(matchValue)}`) : "")}${(matchValue_1 = this$.Request, (matchValue_1 != null) ? (($007CNotEmpty$007C_$007C(matchValue_1) != null) ? ((request = matchValue_1, `
Request: ${request}`)) : "") : "")}${(matchValue_2 = this$.Content, (matchValue_2 != null) ? (($007CNotEmpty$007C_$007C(matchValue_2) != null) ? ((content = matchValue_2, `
Response: ${content}`)) : "") : "")}`;
}

export function Http_HttpStatus_Create_Z68B0E341(code, label, content) {
    return new Http_HttpStatus(code, label, content, undefined, new Http_HttpVerb(0, []), undefined);
}

export class Http_HttpApiName extends Union {
    constructor(Item) {
        super();
        this.tag = 0;
        this.fields = [Item];
    }
    cases() {
        return ["HttpApiName"];
    }
}

export function Http_HttpApiName_$reflection() {
    return union_type("Shopfoo.Domain.Types.Errors.Http.HttpApiName", [], Http_HttpApiName, () => [[["Item", string_type]]]);
}

export function Http_HttpApiName__get_Code(this$) {
    return this$.fields[0];
}

export const Http_HttpApiNameModule_FakeStore = new Http_HttpApiName("FakeStore");

export const Http_HttpApiNameModule_OpenLibrary = new Http_HttpApiName("OpenLibrary");

export class DataRelatedError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["DataException", "DataNotFound", "DuplicateKey", "DeserializationIssue", "HttpApiError"];
    }
}

export function DataRelatedError_$reflection() {
    return union_type("Shopfoo.Domain.Types.Errors.DataRelatedError", [], DataRelatedError, () => [[["Item", class_type("System.Exception")]], [["Id", string_type], ["Type", string_type]], [["Id", string_type], ["Type", string_type]], [["ContentToDeserialize", string_type], ["TargetType", string_type], ["ExceptionThrown", class_type("System.Exception")]], [["apiName", Http_HttpApiName_$reflection()], ["status", Http_HttpStatus_$reflection()]]]);
}

export class OperationNotAllowedError extends Record {
    constructor(Operation, Reason) {
        super();
        this.Operation = Operation;
        this.Reason = Reason;
    }
}

export function OperationNotAllowedError_$reflection() {
    return record_type("Shopfoo.Domain.Types.Errors.OperationNotAllowedError", [], OperationNotAllowedError, () => [["Operation", string_type], ["Reason", string_type]]);
}

export class WorkflowError extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["WorkflowCancelled", "WorkflowUndoError"];
    }
}

export function WorkflowError_$reflection() {
    return union_type("Shopfoo.Domain.Types.Errors.WorkflowError", [], WorkflowError, () => [[["step", string_type]], [["reason", string_type]]]);
}

export class Error$ extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["BusinessError", "Bug", "DataError", "OperationNotAllowed", "GuardClause", "Validation", "WorkflowError", "Errors"];
    }
}

export function Error$_$reflection() {
    return union_type("Shopfoo.Domain.Types.Errors.Error", [], Error$, () => [[["Item", class_type("Shopfoo.Domain.Types.Errors.IBusinessError")]], [["Item", class_type("System.Exception")]], [["Item", DataRelatedError_$reflection()]], [["Item", OperationNotAllowedError_$reflection()]], [["Item", Guards_GuardClauseError_$reflection()]], [["Item", list_type(Guards_GuardClauseError_$reflection())]], [["Item", WorkflowError_$reflection()]], [["Item", list_type(Error$_$reflection())]]]);
}

export function Helpers_bug(exn) {
    return new FSharpResult$2(1, [new Error$(1, [exn])]);
}

export function Helpers_operationNotAllowed(operation, reason) {
    return new FSharpResult$2(1, [new OperationNotAllowedError(operation, reason)]);
}

export function Helpers_dataException(exn) {
    return new FSharpResult$2(1, [new DataRelatedError(0, [exn])]);
}

export function Helpers_liftDataRelatedError(result) {
    return Result_MapError((Item) => (new Error$(2, [Item])), result);
}

export function Helpers_liftOperationNotAllowed(result) {
    return Result_MapError((Item) => (new Error$(3, [Item])), result);
}

export function Helpers_liftGuardClause(guardClause) {
    return Result_MapError((Item) => (new Error$(4, [Item])), guardClause);
}

export function Helpers_liftValidation(validation) {
    return Result_MapError((Item) => (new Error$(5, [Item])), validation);
}

export function Helpers_createAndLiftGuardClause(constructor, input) {
    return Helpers_liftGuardClause(constructor(input));
}

export function Helpers_$007CFirstExceptions$007C(exn) {
    return singleton(exn);
}

export function Helpers_$007CFirstException$007C(_arg) {
    let exn;
    const activePatternResult = Helpers_$007CFirstExceptions$007C(_arg);
    if (!isEmpty(activePatternResult)) {
        exn = head(activePatternResult);
    }
    else {
        exn = _arg;
    }
    return exn;
}

export class GuardExtensions {
    constructor() {
    }
}

export function GuardExtensions_$reflection() {
    return class_type("Shopfoo.Domain.Types.Errors.GuardExtensions", undefined, GuardExtensions);
}

export function GuardExtensions_LiftError_ZC7052C1(guardResult) {
    return Helpers_liftGuardClause(Result_Map((value) => {
    }, guardResult));
}

export function GuardExtensions_ToValidation_ZC7052C1(guardResult) {
    return Validation_toValidation(guardResult);
}

export function ErrorCategory_ofError(error) {
    switch (error.tag) {
        case 1:
            return "Bug: Exception";
        case 2:
            switch (error.fields[0].tag) {
                case 1:
                    return "Data Error: Not Found";
                case 3:
                    return "Data Error: Deserialization Issue";
                case 2:
                    return "Data Error: Duplicate Key";
                case 4:
                    return "Data Error: HTTP API Issue";
                default:
                    return "Data Error: Query Issue";
            }
        case 3:
            return "Operation Not Allowed";
        case 4:
            return "Guard Clause";
        case 5:
            return "Validation";
        case 6:
            if (error.fields[0].tag === 1) {
                return "Workflow Undo Error";
            }
            else {
                return "Workflow Cancelled";
            }
        case 7: {
            const errors_1 = toArray(delay(() => map_1(ErrorCategory_ofError, error.fields[0])));
            const errorCategories = join(" | ", errors_1);
            return `${errors_1.length} Errors: ${errorCategories}`;
        }
        default:
            return `Business Error: ${error.fields[0].Code}`;
    }
}

export const ErrorMessageModule_empty = ErrorMessage_Create_27AED5E3("");

function ErrorMessageModule_innerExceptionMessage(exn) {
    return undefined;
}

export function ErrorMessageModule_ofDataError(_arg) {
    let matchResult, exn, id, typeName;
    switch (_arg.tag) {
        case 0: {
            matchResult = 0;
            exn = _arg.fields[0];
            break;
        }
        case 1: {
            if ($007CNotEmpty$007C_$007C(_arg.fields[1]) != null) {
                matchResult = 1;
                id = _arg.fields[0];
                typeName = _arg.fields[1];
            }
            else {
                matchResult = 2;
            }
            break;
        }
        default:
            matchResult = 2;
    }
    switch (matchResult) {
        case 0: {
            const exn_1 = exn;
            return ErrorMessage_Create_27AED5E3(exn_1.message, unwrap(ErrorMessageModule_innerExceptionMessage(exn_1)));
        }
        case 1:
            return ErrorMessage_Create_27AED5E3(`[${typeName}] ${id} not found`);
        default: {
            let matchResult_1, id_1, id_2, typeName_1;
            switch (_arg.tag) {
                case 1: {
                    matchResult_1 = 0;
                    id_1 = _arg.fields[0];
                    break;
                }
                case 2: {
                    if ($007CNotEmpty$007C_$007C(_arg.fields[1]) != null) {
                        matchResult_1 = 1;
                        id_2 = _arg.fields[0];
                        typeName_1 = _arg.fields[1];
                    }
                    else {
                        matchResult_1 = 2;
                    }
                    break;
                }
                default:
                    matchResult_1 = 2;
            }
            switch (matchResult_1) {
                case 0:
                    return ErrorMessage_Create_27AED5E3(`${id_1} not found`);
                case 1:
                    return ErrorMessage_Create_27AED5E3(`[${typeName_1}] ${id_2} already exists`);
                default:
                    switch (_arg.tag) {
                        case 2:
                            return ErrorMessage_Create_27AED5E3(`${_arg.fields[0]} already exists`);
                        case 3: {
                            const exn_2 = _arg.fields[2];
                            return ErrorMessage_Create_27AED5E3(`Failed to deserialize to ${_arg.fields[1]}: ${exn_2.message}
Content: ${_arg.fields[0]}`, unwrap(ErrorMessageModule_innerExceptionMessage(exn_2)));
                        }
                        case 4: {
                            const status = _arg.fields[1];
                            return ErrorMessage_Create_27AED5E3(`Call to ${Http_HttpApiName__get_Code(_arg.fields[0])} API failed with ${Http_HttpStatus__Explain(status)}`, unwrap(status.Content));
                        }
                        default:
                            throw new Error("Match failure: Shopfoo.Domain.Types.Errors.DataRelatedError");
                    }
            }
        }
    }
}

export function ErrorMessageModule_ofWorkflowError(_arg) {
    if (_arg.tag === 0) {
        return ErrorMessage_Create_27AED5E3(`Workflow cancelled at step ${_arg.fields[0]}`);
    }
    else {
        return ErrorMessage_Create_27AED5E3(`Workflow undo failed: ${_arg.fields[0]}`);
    }
}

export function ErrorMessageModule_ofError(_arg) {
    switch (_arg.tag) {
        case 1: {
            const activePatternResult = Helpers_$007CFirstException$007C(_arg.fields[0]);
            return ErrorMessage_Create_27AED5E3(`[Program] Oops, something went wrong: ${activePatternResult.message}`);
        }
        case 2:
            return ErrorMessageModule_ofDataError(_arg.fields[0]);
        case 3: {
            const _arg_1 = _arg.fields[0];
            return ErrorMessage_Create_27AED5E3(`Operation [${_arg_1.Operation}] is not allowed. Reason: ${_arg_1.Reason}`);
        }
        case 4: {
            const _arg_2 = _arg.fields[0];
            return ErrorMessage_Create_27AED5E3(`Guard ${_arg_2.EntityName}: ${_arg_2.ErrorMessage}`);
        }
        case 5:
            return ErrorMessage_Combine_Z57E0834A(map((arg00$0040) => {
                const _arg_3 = arg00$0040;
                return ErrorMessage_Create_27AED5E3(`Guard ${_arg_3.EntityName}: ${_arg_3.ErrorMessage}`);
            }, _arg.fields[0]));
        case 6:
            return ErrorMessageModule_ofWorkflowError(_arg.fields[0]);
        case 7:
            return ErrorMessage_Combine_Z57E0834A(map(ErrorMessageModule_ofError, _arg.fields[0]));
        default: {
            const err = _arg.fields[0];
            return ErrorMessage_Create_27AED5E3(`Business Error ${err.Code}: ${err.Message}`);
        }
    }
}

export class TypeName$1 extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["FullName", "Empty", "Custom"];
    }
}

export function TypeName$1_$reflection(gen0) {
    return union_type("Shopfoo.Domain.Types.Errors.TypeName`1", [gen0], TypeName$1, () => [[], [], [["typeName", string_type]]]);
}

export function Result_zip(resA, resB) {
    const copyOfStruct = resA;
    if (copyOfStruct.tag === 1) {
        const copyOfStruct_1 = resB;
        if (copyOfStruct_1.tag === 1) {
            return new FSharpResult$2(1, [new Error$(7, [ofArray([copyOfStruct.fields[0], copyOfStruct_1.fields[0]])])]);
        }
        else {
            return new FSharpResult$2(1, [copyOfStruct.fields[0]]);
        }
    }
    else {
        const copyOfStruct_2 = resB;
        if (copyOfStruct_2.tag === 1) {
            return new FSharpResult$2(1, [copyOfStruct_2.fields[0]]);
        }
        else {
            return new FSharpResult$2(0, [[copyOfStruct.fields[0], copyOfStruct_2.fields[0]]]);
        }
    }
}

